import * as types from './types';

export const state = {
  box: {},
};

export const mutations = {
  [types.CODE_SET_BOX](state, box) {
    state.box = box;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/code/mutations.js
 **/